<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="290px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ title }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-text-field
                        v-model="textInput"
                        :label="hintText"
                    ></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="setAnswer(true)">{{ $t("ok") }}</v-btn>
                    <v-btn color="error" @click="setAnswer(false)">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "TextInputDialog",

        data () {
            return {
                dialog:    false,
                title:     "",
                textInput: "",
                hintText:  "",
                answer:    null
            }
        },

        watch: {
            dialog (val) {
                if (val) { this.answer = null; }
            }
        },

        methods: {
            /**
             * Возвращение ответа и закрытие диалога
             *
             * @param {bool} val Ответ
             */
            setAnswer (val) {
                this.answer = val;
                this.dialog = false;
            }
        }
    }
</script>
